import { render, staticRenderFns } from "./VEmployerServicesExtension.vue?vue&type=template&id=2be6b03e&scoped=true&lang=pug"
import script from "./VEmployerServicesExtension.vue?vue&type=script&lang=ts"
export * from "./VEmployerServicesExtension.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6b03e",
  null
  
)

export default component.exports